import axios from 'axios';
import { Brand } from '../../treatment-catalog/types/brand.type';

// GET BRANDS
// /ewosapi/v1/shrimps/Feed/${globalCompanyId}/brand
export const getBrand = async (globalCompanyId: string): Promise<Brand[]> => {
  const res = await axios.get(`/ewosapi/v1/shrimps/Feed/${globalCompanyId}/brand`);
  return res.data;
};
